import { Link } from "react-router-dom";

export default function Logo({ light = false }) {
  return (
    <Link
      to="/"
      className="group inline-flex items-center gap-2.5"
      aria-label="Wetterdesign — startsida"
    >
      <img
        src="/logos/wetterdesignlogo.png"
        alt="Wetterdesign logotyp"
        className="h-10 w-auto transition group-hover:scale-[1.04]"
        width="40"
        height="40"
      />
      <span className="leading-tight">
        <span
          className={`block font-display text-lg font-semibold tracking-tight ${
            light ? "text-white" : "text-navy-900"
          }`}
        >
          Wetterdesign
        </span>
        <span
          className={`block text-[10px] font-medium uppercase tracking-[0.22em] ${
            light ? "text-sand-200/80" : "text-navy-500"
          }`}
        >
          Webbyrå · Vid Vättern
        </span>
      </span>
    </Link>
  );
}
